import React, { useState, memo, useCallback } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { IconButton, Popover } from "@mui/material";
import fileupload from "../../../assets/images/fileupload.png";
import send from "../../../assets/images/send.png";
import {
  MessageInputMain,
  InputMain,
  FileUploadButton,
} from "./styles/MessageInputStyle";
import httpRequest from "../../../axios/index";
import { CHATS, ADMIN_CHAT } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

const MessageInput = ({
  SetAllMessages = () => {},
  AllMessages = [],
  scrollToBottom = () => {},
  type = "customers",
  sendTo = "",
}) => {
  const [messageValue, setMessageValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleFileChange = useCallback((event) => {
    const selectedFiles = Array.from(event.target.files);
    const imageFiles = selectedFiles.filter((file) =>
      file.type.startsWith("image/")
    );

    setSelectedImages((prevSelectedImages) => [
      ...prevSelectedImages,
      ...imageFiles,
    ]);
    // Reset the file input value to allow selecting the same files again
    event.target.value = null;
  }, []);

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const SelectEmoji = (emoji) => {
    if (emoji.native) {
      setMessageValue((prevValue) => prevValue + emoji.native);
      setAnchorEl(null);
    }
  };

  const isSubmitDisabled = messageValue === "" && selectedImages?.length === 0;

  const handleSubmit = async (event) => {
    event.preventDefault();
    let url;

    const formData = new FormData();
    formData.append("message", messageValue);

    const images = selectedImages;
    for (let i = 0; i < images.length; i++) {
      formData.append("attachments[]", images[i]);
    }
    if (type === "customers") {
      url = CHATS;
    } else if (type === "admin") {
      url = ADMIN_CHAT;
      formData.append("recipient_slug", sendTo);
    }

    try {
      setLoading(true);
      const resp = await httpRequest.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (resp?.status === 200) {
        const newMessage = resp?.data?.data;
        SetAllMessages([newMessage, ...AllMessages]);
        setTimeout(() => {
          scrollToBottom();
        }, 300);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }

    setMessageValue("");
    setSelectedImages([]);
  };

  const handleRemoveImage = useCallback((imageFile) => {
    setSelectedImages((prevSelectedImages) =>
      prevSelectedImages.filter((img) => img !== imageFile)
    );
  }, []);

  return (
    <MessageInputMain>
      <form onSubmit={handleSubmit}>
        <IconButton
          color="primary"
          aria-label="Icon Button"
          onClick={handleButtonClick}
          disabled={Loading}
        >
          <SentimentSatisfiedAltIcon />
        </IconButton>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Picker data={data} onEmojiSelect={(emoji) => SelectEmoji(emoji)} />
        </Popover>

        <FileUploadButton
          color="primary"
          aria-label="Icon Button"
          disabled={Loading}
        >
          <label htmlFor="file-upload">
            <img src={fileupload} alt="fileupload" />
          </label>
          <input
            type="file"
            id="file-upload"
            style={{ display: "none" }}
            multiple
            accept="image/*"
            onChange={handleFileChange}
          />
        </FileUploadButton>
        <InputMain>
          <input
            type="text"
            placeholder="Write a message"
            value={messageValue}
            onChange={(e) => setMessageValue(e.target.value)}
          />
        </InputMain>
        <IconButton
          color="primary"
          aria-label="Icon Button"
          type="submit"
          disabled={Loading || isSubmitDisabled}
        >
          {Loading ? (
            <CircularProgress size={20} />
          ) : (
            <img src={send} alt="send" />
          )}
        </IconButton>
      </form>
      {selectedImages.length > 0 && (
        <>
          <div className="Images_previews">
            {selectedImages?.map((imageFile, index) => (
              <div key={index} className="previews_image">
                <img
                  src={URL.createObjectURL(imageFile)}
                  alt={`Preview ${index + 1}`}
                />
                <IconButton
                  color="primary"
                  aria-label="Icon Button"
                  className="close_button"
                  onClick={() => handleRemoveImage(imageFile)}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            ))}
          </div>
        </>
      )}
    </MessageInputMain>
  );
};

export default memo(MessageInput);
